import React from 'react';
function Linkedin({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        stroke="transparent"
        fill="currentColor"
        d="M14.45 9.2a4.534 4.534 0 00-4.55 4.527V18.3a.7.7 0 00.7.7h1.633a.7.7 0 00.7-.7v-4.573a1.51 1.51 0 011.672-1.501 1.555 1.555 0 011.362 1.555v4.52a.7.7 0 00.7.7H18.3a.7.7 0 00.7-.7v-4.574A4.535 4.535 0 0014.45 9.2zM7.8 9.9H5.7a.7.7 0 00-.7.7v7.7a.7.7 0 00.7.7h2.1a.7.7 0 00.7-.7v-7.7a.7.7 0 00-.7-.7zM6.75 8.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
      />
    </svg>
  );
}

export default Linkedin;
